import {FiltersRequest, FiltersResponse} from '../../../../models/api/back/create-order/filters';
import {ResponseBase} from "../../../response-base";
import {AppThunk} from "../../../../app/store";
import {ordersDataActions} from "../../../../slices/orders/orders-data-slice";
import {apiActions} from "../../../../slices/api-slice";
import {ApiBaseBack} from "../../api-base-back";
import {
  OptionMaterialFiltersRequest,
  OptionMaterialFiltersResponse,
} from '../../../../models/api/back/create-order/option-material-filters';


export class ApiOptionMaterialFilters extends ApiBaseBack<OptionMaterialFiltersResponse> {
  constructor(param: OptionMaterialFiltersRequest) {
    super(
      'GET',
      '/api/v1/optionMaterialFilters',
      'JSON',
      param,
    );
  }
}

// export const apiFiltersThunk = (param: OptionMaterialFiltersRequest, callback?: () => void, isInit?: boolean): AppThunk => async (dispatch, getState) => {
//   if (!param.optionProductNameId) {
//     dispatch(ordersDataActions.updateData({
//       filter: { filters: [] }
//     }));
//     callback?.();
//     return;
//   }
//   dispatch(apiActions.run(
//     new ApiOptionMaterialFilters(param),
//     {
//       onSuccess: (res: ResponseBase<OptionMaterialFiltersResponse>) => {
//         callback?.();
//         if (!isInit && param.optionProductNameId !== getState().order.itemDetail.itemSelect.value) {
//           return;
//         }
//         dispatch(ordersDataActions.updateData({
//           filter: { filters: res.body.data?.filters || [] },
//         }));
//       },
//       onError: () => {
//         callback?.();
//       },
//     },
//     {
//       apiName: 'filter',
//       ignoreSystemError: true,
//     },
//   ));
// };
